import { render } from "./AppLogo.vue?vue&type=template&id=32c0743c&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import "./AppLogo.vue?vue&type=style&index=0&id=32c0743c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32c0743c"

export default script